module.exports = __webpack_public_path__ + "static/media/nate-jones.56b07407.jpg";